export default __webpack_public_path__ + "static/media/message.69c34b71.png";